var map = {
	"./Instagram.svg": 2799,
	"./border.svg": 8519,
	"./close.svg": 2591,
	"./css3.svg": 9254,
	"./github.svg": 7814,
	"./githubIcon.svg": 2590,
	"./html5.svg": 9752,
	"./icon-briefcase.svg": 158,
	"./icon-figma.svg": 8496,
	"./icon-link.svg": 2094,
	"./icon-mail.svg": 8713,
	"./icon-map-pin.svg": 3799,
	"./letstalk.svg": 5941,
	"./mail.svg": 8139,
	"./mailIcon.svg": 7258,
	"./node-js.svg": 5036,
	"./telegram.svg": 6261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;